import { Box, useTheme } from "@mui/material";
import { Typography } from "@pmag/ui-components";
import { Fragment, type FunctionComponent } from "react";

export type ArticleHeaderInfoProps = {
    articleNumber?: string | null;
    specifications?: string[] | number[] | null;
    /**
     * the variant prop defines the way of how the information is rendered
     * default: year / specification / articleNumber
     * subHeader: <year><specification><articleNumber>
     */
    variant?: "default" | "subHeader";
    year?: string | number | null;
};

export const dataTestId = {
    separator: "sparePartsFinder.articleHeader.modelDetails.separator",
    specification: "sparePartsFinder.articleHeader.modelDetails.specification",
    year: "sparePartsFinder.articleHeader.modelDetails.year",
    articleNumber: "sparePartsFinder.articleHeader.modelDetails.articleNumber",
};

type DetailsElement = {
    dataTestId: string;
    value: string | number;
};

export const ArticleHeaderModelDetails: FunctionComponent<ArticleHeaderInfoProps> = ({
    variant = "default",
    year,
    specifications,
    articleNumber,
}) => {
    const theme = useTheme();

    const elements: DetailsElement[] = [];

    if (year) elements.push({ value: year, dataTestId: dataTestId.year });

    if (specifications && specifications?.length > 0) elements.push({ value: specifications.join(", "), dataTestId: dataTestId.specification });

    if (articleNumber) elements.push({ value: articleNumber, dataTestId: dataTestId.articleNumber });

    return (
        <Typography component="span" variant="body-short-01" color={theme.palette.grey["600"]}>
            {elements.map((element, index) => (
                <Fragment key={element.value}>
                    {variant === "default" && index > 0 && (
                        <Box component="span" data-testid={dataTestId.separator} marginLeft={1} marginRight={1}>
                            /
                        </Box>
                    )}

                    <Box component="span" data-testid={element.dataTestId}>
                        {variant === "default" ? element.value : `<${element.value}>`}
                    </Box>
                </Fragment>
            ))}
        </Typography>
    );
};
